/**
 * Semantic Border Radius Tokens
 *
 * Use these for all border-radius values.
 * rounded="md" = 8px (default for cards, buttons)
 */
const semanticRadii = {
  none: "0px",
  xs: "2px",
  sm: "4px",
  md: "8px", // Default for cards, buttons
  lg: "12px",
  xl: "16px",
  "2xl": "24px",
  "3xl": "32px",
  "4xl": "48px",
  full: "9999px",
};

export default semanticRadii;
export type RadiiToken = keyof typeof semanticRadii;

// Chakra v3 formatted radii tokens
export const radiiTokens = Object.entries(semanticRadii).reduce(
  (acc, [key, val]) => {
    acc[key] = { value: val };
    return acc;
  },
  {} as Record<string, { value: string }>
);
